import level2TestataDellaBolletta       from './level2-01-testata.js';
import level2Fatturazione               from './level2-02-fatturazione.js';
import level2ConsumiDettaglio           from './level2-03-consumi.js';
import level2Comunicazioni              from './level2-04-comunicazioni.js';
import level2MetodologieDiPagamento     from './level2-05-metodologie-di-pagamento.js';

const data = {
    "testata-della-bolletta": {
      label: "Testata della bolletta",
      img: "./images/01-testata.jpg",
      imgDescription: "Dettaglio del primo foglio della bolletta che mette in evidenza la parte superiore.",
      description: "In questa sezione della bolletta trovi raggruppati i dati personali e quelli relativi alla tua fornitura.",
      level2: level2TestataDellaBolletta
    },
    "fatturazione": {
      label: "Fatturazione",
      img: "./images/02-fatturazione.jpg",
      imgDescription: "Immagine che raffigura la prima pagina della bolletta, con evidenziata l'intera area dedicata alla sintesi degli importi fatturati e il dettaglio fiscale.",
      description: "Qui trovi tutte le voci che spiegano in dettaglio le spese che compongono il totale della bolletta.",
      level2: level2Fatturazione
    },
    "consumi-dettaglio": {
      label: "Consumi fatturati e dettaglio letture",
      img: "./images/03-consumi.jpg",
      imgDescription: "Immagine che raffigura la seconda pagina della bolletta, con evidenziata l'area superiore dove sono presenti i consumi fatturati e il dettaglio delle letture.",
      description: "Qui trovi tutte le informazioni relative allo storico dei tuoi consumi come il consumo annuo o l'andamento consumi degli ultimi 12 mesi. Nella bolletta puoi trovare anche le letture utilizzate per la fatturazione.",
      level2: level2ConsumiDettaglio
    },
    "comunicazioni": {
      label: "Comunicazioni per te",
      img: "./images/04-comunicazioni.jpg",
      imgDescription: "Immagine che raffigura il secondo e il terzo foglio della bolletta. Del secondo foglio sono messe in evidenza le informazioni per i clienti e i box laterali.",
      description: "Sulla bolletta abbiamo inserito alcune comunicazioni che possono aiutarti a trovare velocemente il supporto di cui hai bisogno o scoprire servizi utili per gestire più facilmente la tua fornitura.",
      level2: level2Comunicazioni
    },
    "metodologie-pagamento": {
      label: "Metodologie di pagamento",
      img: "./images/05-metodologiedipagamento.jpg",
      imgDescription: "Immagine che raffigura fogli della bolletta con le metodologie di pagamento.",
      description: "Due pagine allegate alla bolletta con un approfondimento sul metodo di pagamento scelto. Puoi trovare tutte le informazioni sulle metodologie di pagamento anche nell'apposita sezione del sito SEN <a href='https://www.servizioelettriconazionale.it/it-IT/bolletta/paga' target='_blank'>\"Paga la Bolletta\"</a>",
      level2: level2MetodologieDiPagamento
    }
  }

  export default data;